<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="중점점검 기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn v-if="popupParam.focusInspectionId && !disabled" label="삭제" :editable="editable" icon="delete_forever" @btnClicked="remove" />
                <c-btn
                  v-show="editable && !disabled"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="focus"
                  :mappingType="saveType"
                  label="저장"
                  icon="save"
                  @beforeAction="savePlan"
                  @btnCallback="saveCallback" 
                />
                <c-btn
                  v-show="editable && popupParam.focusInspectionId && !disabled"
                  :url="completeUrl"
                  :isSubmit="isComplete"
                  :param="focus"
                  mappingType="PUT"
                  label="완료"
                  icon="check"
                  @beforeAction="completePlan"
                  @btnCallback="completeCallback" 
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-text
                  required
                  :afterIcon="
                    editable && !disabled
                      ? [
                          {
                            name: 'search',
                            click: true,
                            callbackName: 'searchMachinery',
                            color: 'teal',
                          },
                          {
                            name: 'close',
                            click: true,
                            callbackName: 'removeMachinery',
                            color: 'red',
                          },
                        ]
                      : null
                  "
                  :editable="editable"
                  :readonly="true"
                  label="형식(규격) - 유해위험기계기구"
                  name="machineryName"
                  v-model="focus.machineryName"
                  @searchMachinery="searchMachinery"
                  @removeMachinery="removeMachinery"
                >
                </c-text>
              </div> -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="점검명"
                  name="focusName"
                  v-model="focus.focusName">
                </c-text>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <c-select
                  required
                  type="edit"
                  :disabled="disabled || Boolean(popupParam.focusInspectionId)"
                  :editable="editable"
                  :comboItems="typeItems"
                  itemText="codeName"
                  itemValue="code"
                  name="machineryTypeCd"
                  label="유형"
                  v-model="focus.machineryTypeCd"
                  @datachange="datachange"
                ></c-select>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <c-datepicker
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="점검일"
                  type="date"
                  name="inspectionDate"
                  v-model="focus.inspectionDate"
                >
                </c-datepicker>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <c-field
                  required
                  :editable="editable"
                  :disabled="disabled"
                  type="user"
                  label="점검자"
                  name="inspectionUserId"
                  v-model="focus.inspectionUserId">
                </c-field>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <c-plant 
                  required
                  :disabled="disabled"
                  :editable="editable" 
                  type="edit" 
                  name="plantCd" 
                  v-model="focus.plantCd" />
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-checkbox
                  :editable="editable"
                  :isFlag="true"
                  label="공통점검항목 관리 여부"
                  name="commonFlag"
                  v-model="focus.commonFlag"
                  @datachange="datachange"
                />
              </div> -->
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tabvertical">
          <c-tab
            type="horizon"
            align="left"
            :tabItems.sync="tabItems"
            :dense="true"
            :inlineLabel="true"
            :splitter="splitter"
            v-model="tab"
            tabClassVertical="leftTabAlign"
          >
            <template v-slot:default="tab">
              <component
                :is="tab.component"
                :focus.sync="focus"
                :disabled="disabled"
              />
            </template>
          </c-tab>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import mixinCommon from '@/js/mixin-page-common'
export default {
  name: 'hazard-focus-inspection-detail',
  mixins: [mixinCommon],
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        focusInspectionId: '',
      }),
    },
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      focus: {
        focusInspectionId: '',  // 중점점검 일련번호
        hhmHazardousMachineryId: '',  // 기계기구 일련번호
        machineryClassificationName: '',
        machineryMasterName: '',
        machineryCdName: '',
        machineryTypeCd: null,
        focusName: '',  // 중점점검명
        plantCd: '',  // 사업장 코드
        inspectionDate: '',  // 점검일자
        inspectionUserId: '',  // 점검자 id
        commonFlag: 'N',  // 공통 체크
        completeFlag: '',  // 공통 체크
        remark: '',  // 검사결과 상세
        regUserId: '', 
        chgUserId: '',  

        emplacementPlace: '',
        machineryClassification: '',
        machineryName: '',
        hazardFocusInspItemModelList: [], // 점검항목
        hazardFocusInspItemCommonModelList: [], // 공통점검항목

        hazardFocusInspEquipModelList: [], // 유해위험기계기구
        deleteHazardFocusInspEquipModelList: [], // 유해위험기계기구 delete list
      },
      splitter: { data: 240 },
      tab: 'equip',
      tabItems: [
        { name: 'equip', icon: 'build', label: '점검관련 대상', component: () => import(`${'./hazardFocusInspectionEquip.vue'}`) },
        { name: 'common', icon: 'edit_note', label: '기계분야_종합 점검항목', component: () => import(`${'./hazardFocusInspectionCommonResult.vue'}`) },
        { name: 'result', icon: 'checklist', label: '유형별 점검항목', component: () => import(`${'./hazardFocusInspectionResult.vue'}`) },
      ],
      addTabItems: [
      ],
      editable: true,
      detailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
      saveCall: {
        saveCallData: '',
      },
      typeItems: [],
      saveUrl: 'transactionConfig.sop.hhm.hazard.focus.insert.url',
      saveType: 'POST',
      isSave: false,
      getUrl: '',
      insertUrl: '',
      updateUrl: '',
      isComplete: false,
      completeUrl: '',
      height: 0,
      commonList: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    mobileSave() {
      return {
        bol: this.editable && !this.disabled,
        uid: uid(),
      }
    },
    disabled() {
      return this.focus.completeFlag === "Y";
    },
    tabHeight() {
      return String(this.contentHeight - 220) + 'px';
    },
  },
  watch: {
    'eventScroll.save'() {
      this.savePlan();
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.focus.inspectionDate = this.$comm.getToday();
      this.getUrl = selectConfig.sop.hhm.hazard.focus.info.get.url;
      this.insertUrl = transactionConfig.sop.hhm.hazard.focus.info.insert.url;
      this.updateUrl = transactionConfig.sop.hhm.hazard.focus.info.update.url;
      this.deleteUrl = transactionConfig.sop.hhm.hazard.focus.info.delete.url;
      this.completeUrl = transactionConfig.sop.hhm.hazard.focus.info.complete.url;
      // list setting

      this.getCommonItems();
      this.getTypeDetail();
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.focusInspectionId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.focusInspectionId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.focus = _result.data;
        },);
      } else {
        this.$set(this.focus, 'inspectionUserId', this.$store.getters.user.userId)
      }
    },
    getTypeDetail() {
      this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HHM_TYPE_CD', 'N');
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.typeItems = _result.data;
      },
      () => {
      });
    },
    getCommonItems() {
      this.$http.url = selectConfig.sop.hhm.hazard.master.item.common.url;
      this.$http.type = 'GET';
      this.$http.param = {};
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, _item => {
         this.focus.hazardFocusInspItemCommonModelList.push({
            focusInspectionId: this.focus.focusInspectionId,
            focusInspectionItemId: uid(),
            checkTypeName: _item.typeName,
            checkItemName: _item.inspectItem,
            sortOrder: _item.sortOrder,
            commonFlag: 'Y',
            hazardFocusInspItemEquipModelList: [],
            checkItemValue: 'HIV0000001',
            regUserId: this.$store.getters.user.userId,
            editFlag: 'C',
          }) 
        })
      },);
    },
    savePlan() {
      if (this.popupParam.focusInspectionId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.focus.regUserId = this.$store.getters.user.userId
              this.focus.chgUserId = this.$store.getters.user.userId

              if (this.focus.commonFlag === 'Y') { 
                this.focus.hazardFocusInspItemCommonModelList = this.$_.clone(this.commonList)
              }
              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.focusInspectionId = _result.data
      this.getDetail();
    },
    completePlan() {
      this.saveUrl = this.completeUrl;
      this.saveType = 'PUT';
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.focus.regUserId = this.$store.getters.user.userId
              this.focus.chgUserId = this.$store.getters.user.userId

              if (this.focus.commonFlag === 'Y') { 
                this.focus.hazardFocusInspItemCommonModelList = this.$_.clone(this.commonList)
              }
              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.focus.focusInspectionId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');

            this.$emit('closePopup')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    searchMachinery() {
      this.popupOptions.title = "유해위험기계기구 검색"; // 유해위험기계기구 검색
      this.popupOptions.param = {
        type: "single",
        plantCd: this.focus.plantCd, 
      };
      this.popupOptions.target = () =>
        import(`${"./hazardEquipmentClassPop.vue"}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeMachineryPopup;
    },
    closeMachineryPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$set(this.focus, 'hhmHazardousMachineryId', data[0].hhmHazardousMachineryId)
        this.$set(this.focus, 'emplacementPlace', data[0].emplacementPlace)
        this.$set(this.focus, 'machineryClassification', data[0].machineryClassification)
        this.$set(this.focus, 'machineryName', data[0].machineryName)
      }
    },
    removeMachinery() {
      this.focus.emplacementPlace = null;
      this.focus.hhmHazardousMachineryId = null;
      this.focus.machineryClassification = null;
      this.focus.machineryName = null;
    },
    datachange(data) {
      this.focus.hazardFocusInspItemModelList = [];
      this.$http.url = selectConfig.sop.hhm.hazard.master.item.list.url;
      this.$http.type = 'GET';
      this.$http.param = {hhmTypeCd: this.focus.machineryTypeCd};
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, _item => {
          this.focus.hazardFocusInspItemModelList.push({
            focusInspectionId: this.focus.focusInspectionId,
            focusInspectionItemId: uid(),
            checkTypeName: _item.typeName,
            checkItemName: _item.inspectItem,
            sortOrder: _item.sortOrder,
            commonFlag: 'N',
            checkItemValue: 'HIV0000001',
            regUserId: this.$store.getters.user.userId,
            editFlag: 'C',
          }) 
        })
      },);
    },
  }
};
</script>
